import moment from 'moment'
import { useState } from 'react'
import { PriorityCodes, RequestType, Status } from './wlmEnums'

const initialState = {
    selectedItem: {} as {
        id?: Number
        actualRequesterId: number
        requestStatus?: number
        effectiveRequesterId: number
        priority?: number
        requestType?: number
        siteId: number
        SiteName: string
        ts_creationDateTime?: Date
        ts_modificationDateTime?: Date
        approverUserId: number
        callbackNumber: number
    },
    startingDate: moment(new Date()).format('MM/DD/YYYY'),
    endingDate: moment(new Date()).format('MM/DD/YYYY'),
    startingTime: '08:00:00',
    endingTime: '16:00:00',
    permittedSites: [{ Id: -1, SiteName: '', TzCode: '' }],
    selectedSite: -1,
    selectedSiteName: '',
    selectedSiteTz: '',
    statusMessage: '',
    messageAsync: '',
    statusType: Status.INFO,
    requestId: 0,
    comments: [] as Object[],
    showSite: true,
    allowSitePick: true,
    pickedRowId: '',
    pickedElement: null,
    dayOfWeeks: [] as boolean[],
    configs: {
        modalities: {} as { [x: string]: string },
        priorities: {} as { [x: string]: string },
        requestTypes: {} as { [x: string]: string },
        examTypes: {} as { [x: string]: string },
    },
    priorities: [] as boolean[],
    requestType: [] as boolean[],
    currentUser: 0,
    permissions: {
        CanDecline: false,
        CanSubmit: false,
        CanCancel: false,
    },
}

const clearForm = (oldState: {
    currentUser: any
    permittedSites: string | any[]
    configs: {
        requestTypes: ArrayLike<unknown> | { [s: string]: unknown }
        modalities: {}
        priorities: { [s: string]: unknown } | ArrayLike<unknown>
    }
}) => {
    const selected = {
        actualRequesterId: oldState.currentUser,
        requestStatus: 1,
        effectiveRequesterId: oldState.currentUser,
        priority: PriorityCodes.routine,
        requestType: RequestType.adhoc,
        siteId: 0,
        SiteName: '',
        approverUserId: -1,
        callbackNumber: -1,
    }

    return {
        ...initialState,
        selectedItem: selected,
        selectedSite: oldState.permittedSites.length > 0 ? oldState.permittedSites[0].id : -1,
        selectedSiteName: oldState.permittedSites.length > 0 ? oldState.permittedSites[0].name : '',
        selectedSiteTz: oldState.permittedSites.length > 0 ? oldState.permittedSites[0].TzCode : '',
        startingDate: moment(new Date()).format('MM/DD/YYYY'),
        endingDate: moment(new Date()).format('MM/DD/YYYY'),
        dayOfWeeks: [true, true, true, true, true, false, false, false],
        priorities: Object.values(oldState.configs.priorities).map((_, index) => {
            if (index === 2) return true
            return false
        }),
        requestType: Object.values(oldState.configs.requestTypes).map((_, index) => {
            if (index === 2) return true
            return false
        }),
    }
}
export default function wlmReducer(state = initialState, action: { type: string; payload: any }) {
    switch (action.type) {
        case 'wlm/clearForm':
            // TODO watch: does the form get cleared properly? is initialState changing by reference so its not empty anymore?
            return clearForm(state)
        default:
            const field = action.type.replace('wlm/set-', '')
            return {
                ...state,
                [field]: action.payload,
            }
    }
}
